/**
 * Navigation Configuration
 * ნავიგაციის კონფიგურაცია
 */

import type { MenuItem } from '@aiia/portal-core';

// Icons as simple SVG components
const DashboardIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);

const KeyIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
  </svg>
);

const WidgetIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
  </svg>
);

const FileIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const ToolIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const PromptIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
  </svg>
);

const SettingsIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const SubscriptionIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
  </svg>
);

const AdminIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

const StatisticsIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);

const UsersIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
  </svg>
);

const PlansIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
  </svg>
);

const InvoiceIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z" />
  </svg>
);

import type { TFunction } from 'i18next';

export const getNavigationItems = (t: TFunction, lang: string): MenuItem[] => {
  const p = `/${lang}`;
  return [
    {
      id: 'examples',
      label: t('nav.examples'),
      path: `${p}/examples`,
      icon: <PromptIcon />,
      badge: 'DEMO',
    },
    {
      id: 'dashboard',
      label: t('nav.dashboard'),
      path: `${p}/dashboard`,
      icon: <DashboardIcon />,
    },
    {
      id: 'api-keys',
      label: t('nav.apiKeys'),
      path: `${p}/api-keys`,
      icon: <KeyIcon />,
    },
    {
      id: 'widgets',
      label: t('nav.widgets'),
      path: `${p}/widgets`,
      icon: <WidgetIcon />,
    },
    {
      id: 'data-files',
      label: t('nav.dataFiles'),
      path: `${p}/data-files`,
      icon: <FileIcon />,
    },
    {
      id: 'tools',
      label: t('nav.tools'),
      path: `${p}/tools`,
      icon: <ToolIcon />,
    },
    {
      id: 'tool-executions',
      label: t('nav.toolExecutions'),
      path: `${p}/tool-executions`,
      icon: <StatisticsIcon />,
    },
    {
      id: 'prompts',
      label: t('nav.prompts'),
      path: `${p}/prompts`,
      icon: <PromptIcon />,
    },
    {
      id: 'analytics',
      label: t('nav.analytics'),
      path: `${p}/analytics`,
      icon: <StatisticsIcon />,
    },
    {
      id: 'subscription',
      label: t('nav.subscription'),
      path: `${p}/subscription`,
      icon: <SubscriptionIcon />,
    },
    {
      id: 'settings',
      label: t('nav.settings'),
      path: `${p}/settings`,
      icon: <SettingsIcon />,
    },
  ];
};

// Admin navigation items (only visible to platform_admin)
export const getAdminNavigationItems = (t: TFunction, lang: string): MenuItem[] => {
  const p = `/${lang}`;
  return [
    {
      id: 'admin-statistics',
      label: t('nav.statistics'),
      path: `${p}/admin/statistics`,
      icon: <StatisticsIcon />,
    },
    {
      id: 'admin-users',
      label: t('nav.users'),
      path: `${p}/admin/users`,
      icon: <UsersIcon />,
    },
    {
      id: 'admin-subscriptions',
      label: t('nav.subscriptions'),
      path: `${p}/admin/subscriptions`,
      icon: <SubscriptionIcon />,
    },
    {
      id: 'admin-plans',
      label: t('nav.plans'),
      path: `${p}/admin/plans`,
      icon: <PlansIcon />,
    },
    {
      id: 'admin-widgets',
      label: t('nav.allWidgets'),
      path: `${p}/admin/widgets`,
      icon: <WidgetIcon />,
    },
    {
      id: 'admin-api-keys',
      label: t('nav.allApiKeys'),
      path: `${p}/admin/api-keys`,
      icon: <KeyIcon />,
    },
    {
      id: 'admin-data-files',
      label: t('nav.allFiles'),
      path: `${p}/admin/data-files`,
      icon: <FileIcon />,
    },
    {
      id: 'admin-invoices',
      label: t('nav.invoices'),
      path: `${p}/admin/invoices`,
      icon: <InvoiceIcon />,
    },
    {
      id: 'admin-gemini-keys',
      label: t('nav.geminiKeys'),
      path: `${p}/admin/gemini-keys`,
      icon: <AdminIcon />,
    },
  ];
};
